import { render } from "./LogoIconCertificata.vue?vue&type=template&id=1efd92ba&ts=true"
import script from "./LogoIconCertificata.vue?vue&type=script&lang=ts"
export * from "./LogoIconCertificata.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__